// unique partial or full cache keys

export enum ExpensesCacheKeys {
  HasExpenses = 'Expenses:HasExpenses',
  ExpensesFilters = 'Expenses:Filters',
  IsExpensesFiltersUpdated = 'Expenses:IsExpensesFiltersUpdated',
  ExpensesToReview = 'Expenses:ToReview',
  ExpensesReviewed = 'Expenses:Reviewed',
  AllExpenses = 'Expenses:AllExpenses',
  CurrentYearDeductibleAmount = 'Expenses:CurrentYearDeductibleAmount',
  CurrentPeriodDeductibleAmount = 'Expenses:CurrentPeriodDeductibleAmount',
  CategoriesPicker = 'Expenses:CategoriesPicker',
  ExpenseDetails = 'Expenses:ExpenseDetails',
  ExpensesSuggestedTransaction = 'Expenses:SuggestedTransaction',
  ExpenseVATTable = 'Expenses:VATTable',
  ExpenseVATCells = 'Expenses:VATCells',
  ExpensesVehiclesWithoutPurchaseDate = 'Expenses:VehiclesWithoutPurchaseDate',
  ExpenseWorkingDaysAndDeductibleAmount = 'Expenses:WorkingDaysAndDeductibleAmount',
  ExpenseCurrencyRates = 'Expenses:CurrencyRates',
  HomeTodoReviewedExpenses = 'Expenses:HomeTodoReviewedExpenses',
  FirstExpense = 'Expenses:FirstExpense',
  TaxLock = 'Expenses:TaxLock',
  ExpensesCategoriesGuessed = 'Expenses:CategoriesGuessed',
  ExpenseBoundingBoxes = 'Expenses:BoundingBoxes',
  BasketItems = 'BasketItems',
  HasUnpaidExpenses = 'Expenses:HasUnpaidExpenses',
  HasOverdueExpenses = 'Expenses:HasOverdueExpenses',
}

export enum TaxesCacheKeys {
  TaxesFilters = 'Taxes:Filters',
  IsTaxesFiltersUpdated = 'Taxes:IsTaxesFiltersUpdated',
  Taxes = 'Taxes',
  StatementBreakdown = 'StatementBreakdown',
  Submissions = 'Submissions',
  GetHebesatz = 'GetHebezats',
  Municipalities = 'municipalities',
  ClosedPeriods = 'Taxes:ClosedPeriods',
  VATPeriods = 'Taxes:VATPeriods',
  TaxImpact = 'Taxes:TaxImpact',
  InitialTaxTips = 'Taxes:InitialTaxTips',
  TaxTips = 'Taxes:TaxTips',
  DocumentTaxSubmission = 'Taxes:DocumentTaxSubmission',
}

export enum TaxesValidationCacheKeys {
  ApplicableExpenses = 'TAXES:ApplicableExpesnses',
  UnvalidatedExpenses = 'TAXES:UnvalidatedExpenses',
  WithoutDocumentsExpenses = 'TAXES:WithoutDocumentsExpenses',
  AlreadySubmittedExpenses = 'TAXES:AlreadySubmittedExpenses',
  FakeExpenses = 'TAXES:FakeExpenses',
  ApplicableRevenues = 'TAXES:ApplicableRevenues',
  UnvalidatedRevenues = 'TAXES:UnvalidatedRevenues',
  UnapplicableRevenues = 'TAXES:UnapplicableRevenues',
  AlreadySubmittedRevenues = 'TAXES:AlreadySubmittedRevenues',
  MinFinSessionStatus = 'TAXES:MinFinSessionStatus',
}

export enum SelectOptionsCacheKeys {
  Async = 'SelectOptions:Async',
  AsyncPaginated = 'SelectOptions:AsyncPaginated',
}

export enum FilesCacheKeys {
  FileURL = 'Files:FileURL',
  S3FileData = 'Files:S3FileData',
}

export enum UserCacheKeys {
  UserData = 'User:UserData',
  CustomersList = 'Customers:CustomersList',
  PeppolCustomersList = 'Customers:PeppolCustomersList',
  PeppolRegistrationCount = 'Customers:PeppolRegistrationCount',
  PeppolRegisterableClients = 'Customers:PeppolRegisterableClients',
  CustomerData = 'Customers:CustomerData',
  CustomerInvitations = 'Customers:CustomerInvitations',
  ValidateSteuernummer = 'User:ValidateSteuernummer',
  UserFinanzamt = 'User:UserFinanzamt',
  UserAssets = 'User:UserAssets',
  UserAccountants = 'User.Accountants',
  UserWorkspaces = 'User.Workspaces',
  UserReceivedWorkspaceInvitations = 'User.ReceivedWorkspaceInvitations',
  UserAccessRequests = 'User.AccessRequests',
  AuthenticationMethods = 'User:AuthenticationMethods',
  TrialNudgeRevenues = 'User:TrialNudgeRevenues',
  TrialNudgeExpenses = 'User:TrialNudgeExpenses',
  TrialNudgeTaxes = 'User:TrialNudgeTaxes',
  TrialNudgeSubmittedTaxes = 'User:TrialNudgeSubmittedTaxes',
  Verifications = 'User:Verifications',
  FeatureCounts = 'User:FeatureCounts',
}

export enum AccountCacheKeys {
  AccountantData = 'Accountant:AccountantData',
}

export enum WorkspaceCacheKeys {
  Workspaces = 'Workspace:List',
  ReceivedInvitations = 'Workspace:ReceivedInvitations',
  SentInvitations = 'Workspace:SentInvitations',
  WorkspaceMembers = 'Workspace:Members',
}

export enum RevenuesCacheKeys {
  IsRevenuesFiltersUpdated = 'Revenues:IsRevenuesFiltersUpdated',
  HasRevenues = 'Revenues:HasRevenues',
  RevenuesFilters = 'Revenues:Filters',
  RevenuesToReview = 'Revenues:ToReview',
  RevenuesReviewed = 'Revenues:Reviewed',
  AllRevenues = 'Revenues:AllRevenues',
  PrimaryRevenueTab = 'Revenues:PrimaryRevenueTab',
  RevenuesClients = 'Revenues:Clients',
  HasAnyClients = 'Revenues:HasAnyClients',
  RecurringRevenues = 'Revenues:Recurring',
  RevenuesClientById = 'Revenues:ClientById',
  RevenueItemById = 'Revenues:RevenueItemById',
  RevenuesQuotes = 'Revenues:Quotes',
  QuotesFilters = 'Revenues:QuotesFilters',
  HasQuotes = 'Revenues:HasQuotes',
  RevenuesClientsSearch = 'Revenues:ClientsSearch',
  CurrentYearIncomeAmount = 'Revenues:CurrentYearIncomeAmount',
  CurrentPeriodIncomeAmount = 'Revenues:CurrentPeriodIncomeAmount',
  RevenuesSuggestedTransaction = 'Revenues:SuggestedTransaction',
  AnnualNetIncome = 'Revenues:AnnualNetIncome',
  MonthlyNetIncome = 'Revenues:MonthlyNetIncome',
  RevenueById = 'Revenues:RevenueById',
  RecurringRevenueById = 'Revenues:RecurringRevenueById',
  CategoriesPicker = 'Revenues:CategoriesPicker',
  RevenuesVATTable = 'Revenues:VATTable',
  RevenuesVATCells = 'Revenues:VATCells',
  CurrencyRate = 'Revenues:CurrencyRate',
  SuggestedItems = 'Revenues:SuggestedItems',
  PriceList = 'Revenues:PriceList',
  CustomUnits = 'Revenues:CustomUnits',
  CalculateItems = 'Revenues:CalculateItems',
  LatestRevenues = 'Revenues:LatestRevenues',
  RevenueClientFieldOptions = 'Revenues:RevenueClientFieldOptions',
  RevenueDetails = 'Revenues:RevenueDetails',
  QuoteDetails = 'Revenues:QuoteDetails',
  HomeTodoReviewedRevenues = 'Revenues:HomeTodoReviewedRevenues',
  FirstRevenue = 'Revenues:FirstRevenue',
  TaxLock = 'Revenues:TaxLock',
  GermanCarComputedItems = 'Revenues:GermanCarComputedItems',
  RecurringList = 'Revenues:RecurringList',
  RecurringJob = 'Revenues:RecurringJob',
  RevenueLogs = 'Revenues:RevenueLogs',
  Communication = 'Revenues:Communication',
  QRCode = 'Revenues:QRCode',
  RevenuesPriceItemsDropdown = 'Revenues:RevenuesPriceItemsDropdown',
  HasSavedPriceItems = 'Revenues:HasSavedPriceItems',
  ClientById = 'Revenues:ClientById',
  ItemsCalculations = 'Revenues:ItemsCalculations',
  ProjectItemsCalculations = 'Revenues:ProjectItemsCalculations',
  ProjectItems = 'Revenues:ProjectItems',
  GermanCarPrivateUseCategory = 'Revenues:GermanCarPrivateUseCategory',
  RecurringClients = 'Revenues:RecurringClients',
  RecurringListByClientId = 'Revenues:RecurringListByClientId',
  RevenuePaymentAmount = 'Revenues:RevenuePaymentAmount',
  RevenueProject = 'Revenues:RevenueProject',
  RevenueExtendProject = 'Revenues:RevenueExtendProject',
}

export enum BankTransactionsCacheKeys {
  BankTransactionsFilters = 'BankTransactions:Filters',
  IsBankTransactionsFiltersUpdated = 'BankTransactions:IsBankTransactionsFiltersUpdated',
  HasTransactions = 'BankTransactions:HasTransactions',
  Cards = 'BankTransactions:Cards',
  Connectors = 'BankTransactions:Connectors',
  SettingsConnectors = 'BankTransactions:SettingsConnectors',
  LinkingExpenses = 'BankTransactions:LinkingExpenses',
  LinkingCreditNotesOnPurchase = 'BankTransactions:LinkingCreditNotesOnPurchase',
  LinkingRevenue = 'BankTransactions:LinkingRevenue',
  LinkingCreditNotesOnSale = 'BankTransactions:LinkingCreditNotesOnSale',
  CashAvailableFactors = 'BankTransactions:CashAvailableFactors',
  LinkedRevenues = 'BankTransactions:LinkedRevenues',
  LinkedExpenses = 'BankTransactions:LinkedExpenses',
  TransactionById = 'BankTransactions:TransactionById',
  TransactionsList = 'BankTransactions:TransactionsList',
  TransactionsListByStatus = 'BankTransactions:TransactionsListByStatus',
  PaymentLinkedList = 'BankTransactions:PaymentLinkedList',
  SuggestedClassification = 'BankTransactions:SuggestedClassification',
  TransactionDetails = 'BankTransactions:TransactionDetails',
  HomeClassifiedTransactionsQuery = 'BankTransactions:HomeClassifiedTransactionsQuery',
  CreditCardStatementsList = 'BankTransactions:CreditCardStatementsList',
  CreditCardStatement = 'BankTransactions:CreditCardStatement',
  CreditCardStatementTransactions = 'BankTransactions:CreditCardStatementTransactions',
  CreditCardStatementCSVFileData = 'BankTransactions:CreditCardStatementCSVFileData',
  CreditCardStatementBoundingBoxes = 'BankTransactions:CreditCardStatementBoundingBoxes',
  SimilarTransaction = 'BankTransactions:SimilarTransaction',
  OngoingOnboarding = 'BankTransactions:OngoingOnboarding',
  StandingOrders = 'BankTransactions:StandingOrders',
  StandingOrderById = 'BankTransactions:StandingOrderById',
  CompletedOnboarding = 'BankTransactions:CompletedOnboarding',
  AccountStatements = 'BankTransactions:AccountStatements',
}

export enum DocumentsRepositoryCacheKeys {
  DocumentsRepositoryFilters = 'DocumentsRepository:Filters',
  IsDocumentsRepositoryFiltersUpdated = 'DocumentsRepository:IsDocumentsRepositoryFiltersUpdated',
  DocumentsList = 'DocumentsRepository:DocumentsList',
  AllTags = 'DocumentsRepository:AllTags',
  HasDocuments = 'DocumentsRepository:HasDocuments',
  DocumentFields = 'DocumentsRepository:DocumentFields',
  FirstDocument = 'DocumentsRepository:FirstDocument',
}

export enum BanksCacheKeys {
  BEBanks = 'Banks:BEBanks',
  BANK_TAX_TIPS = 'Banks:BANK_TAX_TIPS',
  BANKS_LIST = 'BANKS:BANKS_LIST',
}

export enum DataExportCacheKeys {
  HasTransactions = 'DataExport:HasTransactions',
  ExportedDataFile = 'DataExport:ExportedDataFile',
  ExportHistory = 'DataExport:ExportHistory',
}

export enum QRCodeKeys {
  PaidList = 'QRCodeKeys:PaidList',
}

export enum FilesUrls {
  FileUrl = 'FilesUrls:FileUrl',
  FileBlob = 'FilesUrls:FileBlob',
}

export enum VehiclesCacheKeys {
  VehiclesList = 'Vehicles:VehiclesList',
  Vehicle = 'Vehicles:Vehicle',
}

export enum CountriesCacheKeys {
  CountriesList = 'Countries:CountriesList',
}

export enum AnalyticsCacheKeys {
  AnalyticsMetric = 'Analytics:Metric',
}

export enum MFACacheKey {
  getMFA = 'MFA:Get',
  newTOTP = 'MFA:NewTOTP',
  verifyTOTP = 'MFA:VerifyTOTP',
  disableTOTP = 'MFA:DisableTOTP',
}

export enum SignupCacheKeys {
  Enterprises = 'Signup:Enterprises',
  SuggestedOccupation = 'Signup:SuggestedOccupation',
}

export enum SubscriptionsCacheKeys {
  SubscriptionPlans = 'Subscriptions:SubscriptionPlans',
}

export enum FontsCacheKeys {
  Font = 'Fonts:Font',
}

export enum AmortizationCacheKeys {
  CategorisedAssets = 'Amortization:CategorisedAssets',
  Asset = 'Amortization:Asset',
  Periods = 'Amortization:Periods',
  Items = 'Amortization:Items',
  LockedPeriods = 'Amortization:LockedPeriods',
}

export enum YearlyReviewCacheKeys {
  YearlyReviewData = 'YearlyReview:YearlyReviewData',
}

export enum IntegrationsCacheKeys {
  PeppolIntegration = 'Integrations:PeppolIntegration',
  PeppolIntegrationById = 'Integrations:PeppolIntegrationById',
  ClientPeppolIntegrationStatus = 'Integrations:ClientPeppolIntegrationStatus',
  PeppolSwanProfile = 'Integrations:PeppolSwanProfile',
  PeppolAccountableProfile = 'Integrations:PeppolAccountableProfile',
  PeppolUserIbans = 'Integrations:PeppolUserIbans',
  PeppolBECompanyNames = 'Integrations:PeppolBECompanyNames',
}

export enum OtherCacheKeys {
  ItemsCalculations = 'Other:ItemsCalculations',
  ExchangeRates = 'Other:ExchangeRates',
  SuggestedTransaction = 'Other:SuggestedTransaction',
}

export enum AICacheKeys {
  ConversationMessages = 'AI:ConversationMessages',
  ConversationUsage = 'AI:ConversationUsage',
  ConversationsList = 'AI:ConversationList',
  ConversationsListYearlyReview = 'AI:ConversationListYearlyReview',
  ConversationMetadata = 'AI:ConversationMetadata',
  SuggestedQuestions = 'AI:SuggestedQuestions',
  PredictCategory = 'AI:PredictCategory',
  SearchCategories = 'AI:SearchCategories',
}

export enum CardsProductsCacheKeys {
  Cards = 'CardsProductsList',
}

export enum ExportedDocCountCacheKeys {
  ActualExportedDocCount = 'ActualExportedDocCount',
}
